export default function() {
  return new Worker(__webpack_public_path__ + "v2.716/checksum.worker.bundle.worker.js");
}
